export interface IWatrTrip {
    id: number;
    travelRequestId: number;
    tripId: number;
    tripDate?: Date;
    startDate?: Date;
    endDate?: Date;
    tripReasonId: number;
    tripReason?: string;
    tripMiles?: number;
    reimbursementRate?: number;
    reimbursementAmount?: number;
    tripStatus: number;
    canEdit: boolean;
    isLocked: boolean;
    requiresReview: boolean;
    index: number;
    createdDateTime: Date;
    lastUpdated?: Date;
    createdByUserId?: number;
    modifiedByUserId?: number;
    lineItemsCount?: number;
    approvedLineItemsCount?: number;
    declinedLineItemsCount?: number;
    tripStatusDescription?: string;
    canEditDescription?: string;
    formattedTripDate?: string;
    formattedStartDate?: string;
    formattedEndDate?: string;
    dateRangeFormatted?: string;
}

